module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-collect"
  }, [_c('img', {
    attrs: {
      "src": require("../images/personal_center/work-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("你所访问的作品已下架或删除，点击"), _c('router-link', {
    attrs: {
      "to": "/s-mart/market"
    }
  }, [_vm._v("市场")]), _vm._v("查看其他作品。")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-616f22a8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/no_collect.vue
// module id = fCFf
// module chunks = 15